import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class Dropdown extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    // Elements
    this.dropdownMenu = this.element
      .querySelector(this.elements.dropdownMenu);
    this.dropdownButton = this.element
      .querySelector(this.elements.dropdownButton);

    // Inits
    $(this.dropdownButton).dropdown();
  }
}
